export function getPackageDirectoryName() {
    return 'package';
}